<template>
  <div class="contract-signer-bd tb" v-if="funcView.contract_signer_list">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.contractNo"
            :placeholder="$t('crm_contract_signer.qsrhtbh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <!-- 这个空的span用于fix action插槽内容不渲染问题 -->
          <span></span>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.contract_signer_sign && [0,1].includes(scope.row.signingState)"
            @click="sign(scope.row.signingUrl)"
          >{{ funcView.contract_signer_sign }}</el-button>
          <el-button
            type="text"
            size="mini"
            @click="download(scope.row)"
            v-if="funcView.contract_signer_download && checkDownloadVisible(scope.row)"
          >{{ funcView.contract_signer_download }}</el-button>
          <el-button
            type="text"
            size="mini"
            @click="preview(scope.row.previewUrl)"
            v-if="funcView.contract_signer_preview"
          >{{ funcView.contract_signer_preview }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 图片预览 -->
    <el-dialog
      v-drag-dialog
      :title="$t('crm_contract_signer.tu_pian_yu_lan')"
      :visible.sync="showImg"
    >
      <img
        width="100%"
        :src="previewImg"
        alt
      />
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';

export default {
  name: 'contract_signer',
  data() {
    return {
      tableCode: 'contract_signer',
      totalRows: null,
      tableList: [],
      formSearch: {
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractNo: '',
        sginnerId: '',
      },
      showImg: false,
      previewImg: '',
    };
  },
  methods: {
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getList();
    },
    // 打开第三方签署地址
    sign(url) {
      window.open(url);
    },
    preview(url) {
      // this.showImg = true;
      // this.previewImg = url;
      window.open(url);
    },
    // 判断是否允许下载.
    // 签署状态为已签署才允许显示下载按钮
    checkDownloadVisible(row) {
      if (!this.dicMap.signing_state) {
        return false;
      }
      return `${this.dicMap.signing_state.sign_yes}` === `${row.econtractSigningState}`;
    },
    download(row) {
      // const { econtractId } = row;
      // const url = `${apis.EcontractGetDownloadUrl}/${econtractId}`;

      // this.$getJSON(url, {}).then((res) => {
      //   window.open(res.data);
      // });
      // 接口返回字段定义为eContractAttachment，但实际返回econtractAttachment，这里做兼容处理
      const { econtractAttachment, eContractAttachment } = row;
      window.open(eContractAttachment || econtractAttachment);
    },
    getList() {
      this.$getJSON(apis.econtractPageSigner, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();
    this.getList();
    this.getDicMap('signing_state');
    // this.$getJSON(`${apis.EcontractGetDownloadUrl}/161950666901000004`).then(res => {
    //   console.log('mounted', res);
    // });
  },
};
</script>

<style></style>
